import ModalView from 'views/components/modalView';
import I18n from 'i18n';

export default class UnitOrderModalView extends ModalView {
    initialize(options) {
        this.unitType = options.unitType;
        this.usage = options.usage;
    }

    serializeData() {
        return {
            headline: this._modalHeadline(),
            confirmation: this._modalTitle(),
            warning: this._modalBody(),
            confirmationLabel: this._confirmationLabel(),
            showHeader: true,
            cancelLabel: this._cancelLabel(),
            confirmationButtonStyle: 'button--primary',
            showButtons: true
        };
    }

    _modalTitle() {
        return this._modalHeadline();
    }

    _modalHeadline() {
        return I18n.t(
            'webapp.general.modals.confirm_order.title', { unit_name: this._unitName() }
        );
    }

    _unitName() {
        return I18n.t(`webapp.general.products.${this.unitType}`);
    }

    _modalBody() {
        return I18n.t(
            'webapp.general.modals.confirm_order.body', {
                unit_name: this._unitName(),
                unit_count: this.usage.currentUnitUsage(this.unitType),
                unit_price: this.usage.unitPrice(this.unitType)
            }
        );
    }

    _confirmationLabel() {
        return I18n.t(
            'webapp.general.modals.confirm_order.button_confirm'
        );
    }

    _cancelLabel() {
        return I18n.t(
            'webapp.general.modals.confirm_order.button_cancel'
        );
    }
}
